import React from 'react'
import styled from 'styled-components'
import { colors } from 'theme'
import MenuIcon from '@mui/icons-material/Menu';

const DragHandleContainer = styled.div<{ isDragging?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: grab;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  
  &:active {
    cursor: grabbing;
  }
  
  ${({ isDragging }) => isDragging && `
    cursor: grabbing;
    background-color: ${colors.gray[300]};
  `}
`

interface DragHandleProps {
  id: string
  children?: React.ReactNode
}

const DragHandle: React.FC<DragHandleProps> = ({ id: _id, children }) => {
  return (
    <DragHandleContainer isDragging={false}>
      {children || (
        <MenuIcon sx={{ color: "#ccc", fontSize: 20 }} />
      )}
    </DragHandleContainer>
  )
}

export default DragHandle 